// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2f3371d6","59":"3b94edf4","79":"4f6c8d0a","105":"b94beb68","119":"fca00e7c","453":"4717f8d8","667":"eae051b8","777":"c75b3154","786":"d194686b","806":"6c44e2ff","860":"cacb22d2","971":"669228f8"}[chunkId] + ".chunk.js";
};